import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Box, Button, Box as Container } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { LogoHeader } from 'components/header/LogoHeader'
import { PathNames } from 'constants/General'
import { ExternalLinks } from 'constants/links'
import { forceLogout } from 'utils/auth/utils'
import { redirectToPath } from 'utils/utils'

const AccountError = () => {
  const { t } = useTranslation()
  const { state: sentryTraceId } = useLocation()

  return (
    <Container height="screen" width="full" flexCol>
      <LogoHeader />
      <Box paddingX={60} className="bg-surface-static h-full">
        <Box flexCol gapY={24} justify="center" height="full" className="max-w-[600px]">
          <Lottie src="connection-error" />
          <h1 className="text-h1">{t('errorMessages.errorHeading')}</h1>
          <p className="text-foreground-subdued">
            {` ${t('errorMessages.weApologiseForInconvenience')}`}
            {` ${t('errorMessages.pleaseTryTo')} `}
            <Button
              variant="ghost"
              noPadding
              onClick={() => {
                redirectToPath(PathNames.DASHBOARD)
              }}
            >
              {t('errorMessages.refreshPage')}
            </Button>
            {` ${t('errorMessages.or')} `}
            <Button
              variant="ghost"
              noPadding
              onClick={() => {
                forceLogout()
              }}
            >
              {t('errorMessages.login.retry')}
            </Button>
            {`. `}
            {` ${t('errorMessages.ifTheProblemPersists')}, `}
            {` ${t('errorMessages.please').toLowerCase()} `}

            <ExternalLink href={ExternalLinks.CONTACT_SUPPORT}>
              {t('errorMessages.contactSupport')}
            </ExternalLink>
            {` ${t('errorMessages.forAssistance')}`}

            {sentryTraceId && (
              <p>
                {t('errorMessages.traceId')}: {sentryTraceId}
              </p>
            )}
          </p>
        </Box>
      </Box>
    </Container>
  )
}

export default AccountError
